import React from "react";
import Graph from "../../../../etc/Graph";
import LineChart from "../../../../etc/LineChart";

const DDeptMajorArticle = (parent) => {
    const meta = parent.meta;
    const result = {};

    return (
        <div className="mt-65">
            <div className="d-flex justify-content-between align-items-center mb-px-26">
                <div className="d-flex align-items-center">
                    <h3 className="con-title">학과 주요 등재 리스트(논의)</h3>
                </div>
            </div>
            <div>
                <div className="line-list-group">
                    <div className="d-flex document-list-item">
                        <div className="item-info-group">
                            <a href="#" className="item-subject font-weight-400">Efficient food service
                                chain management considering substitute products</a>
                            <div className="item-info">
                                <div className="info-cell">ASIA PACIFIC JOURNAL OF MARKETING AND
                                    LOGISTICS
                                </div>
                                <div className="info-cell">2020, 30(1), 125~134</div>
                            </div>
                            <div className="item-options">
                                <div className="options-cell">
                                    <div className="badge-group">
                                        <div className="badge-group-inner">
                                            <div className="badge bg-lightpurple">SCIE</div>
                                            <div className="badge bg-lightgreen">KCI</div>
                                            <div className="badge bg-lightorange">SCOPUS</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="options-cell"><strong>인용횟수</strong>Wos 6 · Scopus 24 ·
                                    KCI
                                    15
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex-auto align-self-center font-size-14 color-lightblack pl-2 pr-2">학과논문 <strong
                            className="color-lightblue">20</strong></div>
                    </div>
                    <div className="d-flex document-list-item">
                        <div className="item-info-group">
                            <a href="#" className="item-subject font-weight-400">Efficient food service
                                chain management considering substitute products</a>
                            <div className="item-info">
                                <div className="info-cell">ASIA PACIFIC JOURNAL OF MARKETING AND
                                    LOGISTICS
                                </div>
                                <div className="info-cell">2020, 30(1), 125~134</div>
                            </div>
                            <div className="item-options">
                                <div className="options-cell">
                                    <div className="badge-group">
                                        <div className="badge-group-inner">
                                            <div className="badge bg-lightpurple">SCIE</div>
                                            <div className="badge bg-lightgreen">KCI</div>
                                            <div className="badge bg-lightorange">SCOPUS</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="options-cell"><strong>인용횟수</strong>Wos 6 · Scopus 24 ·
                                    KCI
                                    15
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex-auto align-self-center font-size-14 color-lightblack pl-2 pr-2">학과논문 <strong
                            className="color-lightblue">20</strong></div>
                    </div>
                    <div className="d-flex document-list-item">
                        <div className="item-info-group">
                            <a href="#" className="item-subject font-weight-400">Efficient food service
                                chain management considering substitute products</a>
                            <div className="item-info">
                                <div className="info-cell">ASIA PACIFIC JOURNAL OF MARKETING AND
                                    LOGISTICS
                                </div>
                                <div className="info-cell">2020, 30(1), 125~134</div>
                            </div>
                            <div className="item-options">
                                <div className="options-cell">
                                    <div className="badge-group">
                                        <div className="badge-group-inner">
                                            <div className="badge bg-lightpurple">SCIE</div>
                                            <div className="badge bg-lightgreen">KCI</div>
                                            <div className="badge bg-lightorange">SCOPUS</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="options-cell"><strong>인용횟수</strong>Wos 6 · Scopus 24 ·
                                    KCI
                                    15
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex-auto align-self-center font-size-14 color-lightblack pl-2 pr-2">학과논문 <strong
                            className="color-lightblue">20</strong></div>
                    </div>
                    <div className="d-flex document-list-item">
                        <div className="item-info-group">
                            <a href="#" className="item-subject font-weight-400">Efficient food service
                                chain management considering substitute products</a>
                            <div className="item-info">
                                <div className="info-cell">ASIA PACIFIC JOURNAL OF MARKETING AND
                                    LOGISTICS
                                </div>
                                <div className="info-cell">2020, 30(1), 125~134</div>
                            </div>
                            <div className="item-options">
                                <div className="options-cell">
                                    <div className="badge-group">
                                        <div className="badge-group-inner">
                                            <div className="badge bg-lightpurple">SCIE</div>
                                            <div className="badge bg-lightgreen">KCI</div>
                                            <div className="badge bg-lightorange">SCOPUS</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="options-cell"><strong>인용횟수</strong>Wos 6 · Scopus 24 ·
                                    KCI
                                    15
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex-auto align-self-center font-size-14 color-lightblack pl-2 pr-2">학과논문 <strong
                            className="color-lightblue">20</strong></div>
                    </div>
                    <div className="d-flex document-list-item">
                        <div className="item-info-group">
                            <a href="#" className="item-subject font-weight-400">Efficient food service
                                chain management considering substitute products</a>
                            <div className="item-info">
                                <div className="info-cell">ASIA PACIFIC JOURNAL OF MARKETING AND
                                    LOGISTICS
                                </div>
                                <div className="info-cell">2020, 30(1), 125~134</div>
                            </div>
                            <div className="item-options">
                                <div className="options-cell">
                                    <div className="badge-group">
                                        <div className="badge-group-inner">
                                            <div className="badge bg-lightpurple">SCIE</div>
                                            <div className="badge bg-lightgreen">KCI</div>
                                            <div className="badge bg-lightorange">SCOPUS</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="options-cell"><strong>인용횟수</strong>Wos 6 · Scopus 24 ·
                                    KCI
                                    15
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex-auto align-self-center font-size-14 color-lightblack pl-2 pr-2">학과논문 <strong
                            className="color-lightblue">20</strong></div>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <div className="text-center">
                    <button className="btn btn-outline-gray btn-lg"><span
                        className="icon icon-size-24 icon-plus-black align-top mr-2"></span><strong>논문
                        전체보기</strong></button>
                </div>
            </div>
        </div>
    );
};

export default DDeptMajorArticle;
